import { Map } from 'immutable';
import reducerChain from '../helpers/chain';
import Constants from '../../constants';
import { viewReducerMerger } from '../helpers/views';
import { ACTION_SUCCESS } from '../../constants/action-status';

export const DEFAULT_STATE = Map({
	hasMore: false,
	totalCount: 0,
});

const answers = viewReducerMerger(
	[Constants.FETCH_ANSWERS, Constants.FETCH_ANSWER_COUNT],
	'answers',
);

const answerCount = (state = DEFAULT_STATE, action) => {
	switch (action.type) {
		case `${Constants.DELETE_ANSWER}_${ACTION_SUCCESS}`:
			return state.set('totalCount', Math.max(state.get('totalCount') - 1, 0));
		case `${Constants.CREATE_ANSWER}_${ACTION_SUCCESS}`:
			return state.set('totalCount', state.get('totalCount') + 1);
	}
	return state;
};

export default reducerChain([answers, answerCount], DEFAULT_STATE);
